import React, { useEffect, useState, useRef } from "react";
import FooterButton from "./FooterButton";
import "../assets/css/VinDetails.css";
import "../assets/css/global.css";
import { path_Operation, vinDetailsHeader } from "../constants/constVariables";
import { useDispatch } from "react-redux";
import Dropdown from "./Dropdown";
import { useLocation, useNavigate } from "react-router-dom";
import leftArrow from "../assets/images/left-arrow-black.png";
import { vinsDetailsApi } from "../utils/apiServices";
import { VinsDetails } from "../redux/actions/vinsAction";
import DataNotFound from "./DataNotFound";
import { marker } from "../constants/MapContainer";
import { dateFormat, postUsageAnalyticsCall } from "../constants/Utils";
import BackButton from "../clientComponents/BackButton/BackButton";
import { CustomTab } from "../atomicComponents";
import Loader from "./Loader";
import { useAuthorizationContext } from "../providers/AuthorizationHandler/AuthorizationHandler";

const VinDetails = (props) => {
    const location = useLocation();
    // console.log("Location Information", location.state.data);
    const [vinInfo, setVinInfo] = useState();
    const [isModalOpen, setModalIsOpen] = useState(false);
    const [pageLeaveTime, setPageLeaveTime] = useState();
    const errorMessageRef = useRef(null);

    const dispatch = useDispatch();
    const { user } = useAuthorizationContext();
    const handleButton = (val) => {
        if (val === "SHARE") {
            // toggleModal();
            <a
                href={`mailto:?subject=TYV - ${vinInfo[0].vin_number ? vinInfo[0].vin_number : "TYV"
                    }&body=Track Your Vehicle. Check this link http://maps.google.com/maps?q=loc:${vinInfo[0].vin_coordinates[0]?.lat
                    },${vinInfo[0].vin_coordinates[0]?.lng}.`}
                data-action="share/email/share"
                title="Share by Email"
                target="_blank"
                rel="noreferrer"
            ></a>;
        }
    };

    const vinDetailsCall = async () => {
        if (location?.state?.data["vin_number"]) {
            const response = await vinsDetailsApi(location.state.data["vin_number"]);
            var data = response.data.data.map(function (obj, index) {
                obj.updated_at = dateFormat(obj.updated_at);
                obj.last_sync_date = dateFormat(obj.last_sync_date);
                obj.fuel_vin_fk__fuel_updated_at = dateFormat(obj.fuel_vin_fk__fuel_updated_at);
                return Object.assign({}, obj);
            });
            dispatch(VinsDetails(data));
            setVinInfo(data);
            // console.log("vinInfo = ", data)
        }
    };

    useEffect(() => {
        vinDetailsCall();
        setPageLeaveTime(new Date())
    }, []);
    const navigate = useNavigate();
    const browserBack = () => {
        navigate(-1);
    };
    useEffect(() => {
        return () => {
            if (new Date() - pageLeaveTime) {
                const a = path_Operation?.filter((d, i) => {
                    return d?.name == location?.pathname
                })
                postUsageAnalyticsCall(user?.name, user?.userID, a[0]?.pageName ? a[0]?.pageName : location?.pathname, pageLeaveTime, a[0]?.operation ? a[0]?.operation : 'view', (new Date() - pageLeaveTime))
            }
        }
    }, [pageLeaveTime])
    useEffect(() => {
        if (vinInfo && !vinInfo[0].zone_fk__zone_id && !vinInfo[0].area_fk__area_id) {
            errorMessageRef.current.innerHTML = "This Vehicle is not present in any of the defined zones or areas."
        }

        if (vinInfo && !vinInfo[0]?.vin_coordinates) {
            errorMessageRef.current.innerHTML = "This Vehicle location is not available."
            document.getElementById("Share on Email").disabled = true;
        }
        if (vinInfo && vinInfo[0].vin_coordinates) {
            marker(
                vinInfo[0],
                {
                    name: vinInfo[0].area_fk__area_name,
                    coordinates: vinInfo[0].area_fk__area_coordinates,
                },
                {
                    name: vinInfo[0].zone_fk__zone_name,
                    coordinates: vinInfo[0].zone_fk__zone_coordinates,
                }
            );
        }

    }, [errorMessageRef, vinInfo])
    var email_share_link = ''
    if (vinInfo && vinInfo[0].vin_coordinates) {
        // console.log("vininfo = ", vinInfo)
        var email_share_link = `mailto:?subject=TYV${vinInfo ? vinInfo[0]?.vin_number ? " - " + vinInfo[0]?.vin_number : '' : ""}`
            + '&amp;'
            + `&body=Track Your Vehicle.%0D%0A %0D%0A Check this link http://www.google.com/maps/place/${vinInfo ? vinInfo[0]?.vin_coordinates[0]?.lat + "," + vinInfo[0]?.vin_coordinates[0]?.lng + "/@" + vinInfo[0]?.vin_coordinates[0]?.lat + "," + vinInfo[0]?.vin_coordinates[0]?.lng : ''},15z %0D%0A `
    }
    return (
        <>
            {vinInfo ? (
                <>
                    {/* <Breadcrumb /> */}
                    <div className="breadcrumb">
                        <BackButton
                            basePath={
                                location.pathname == "/dashboard/all-VINs/vin-details"
                                    ? "all Vehicle"
                                    : location.pathname == "/dispatched/vin-details"
                                        ? "dispatched"
                                        : location.pathname == "/dashboard/vin-details"
                                            ? "dashboard"
                                            : null
                            }
                            action={"Vehicle details"}
                            handleClick={browserBack}
                        />
                    </div>
                    <div className="headerwithcount">
                        <div className='countdiv'>
                            <CustomTab
                                withOutCount
                                isSelected={false}
                                title={"Vehicle Details"}
                            />
                        </div>
                        <div className="blankdiv" />
                    </div>
                    {/* <Header name="VIN Details" search={false} filter={false} /> */}
                    {/* for mobile */}
                    <div
                        className="mob-secondary-header mob-secondary-navbar regularFont"
                        style={{ backgroundColor: "#FFF" }}
                    >
                        <div className="mob-header-heading" onClick={() => browserBack()}>
                            <img src={leftArrow} alt="back" /> Back
                        </div>
                        <Dropdown hidden={false} />
                    </div>
                    {/* for mobile */}
                    <div className="vin-details-container">
                        <div className="vin-details-main-container">
                            <div className="vin-details-header mediumFont">Vehicle Details</div>
                            <div className="vehicle-detail-container">
                                <div className="vehicle-detail-inner-container">
                                    {vinInfo?.map((vin, index) => {
                                        return (
                                            <>
                                                <div className="vin-header-data-container">
                                                    <span className="vin-header smallFont">
                                                        {vinDetailsHeader[0]}
                                                    </span>
                                                    <span className="vin-data smallFont">
                                                        {vin?.vin_number != "" ? vin?.vin_number : "-"}
                                                    </span>
                                                </div>
                                                <div className="vin-header-data-container">
                                                    <span className="vin-header smallFont">
                                                        {vinDetailsHeader[1]}
                                                    </span>
                                                    <span className="vin-data smallFont">
                                                        {vin.area_fk__area_name == null && vin.zone_fk__zone_name == null ?
                                                            "-" :

                                                            vin?.zone_fk__zone_name == null ?
                                                                vin?.area_fk__area_name
                                                                    ?.toLowerCase()[0]
                                                                    .toUpperCase() +
                                                                vin.area_fk__area_name?.slice(1).toLowerCase()
                                                                :
                                                                vin?.zone_fk__zone_name
                                                                    ?.toLowerCase()[0]
                                                                    .toUpperCase() +
                                                                vin.zone_fk__zone_name?.slice(1).toLowerCase()
                                                        }
                                                    </span>
                                                </div>
                                                <div className="vin-header-data-container">
                                                    <span className="vin-header smallFont">
                                                        {vinDetailsHeader[2]}
                                                    </span>
                                                    <span className="vin-data smallFont">
                                                        {vin?.vin_type != null ? vin?.vin_type : "-"}
                                                    </span>
                                                </div>
                                                <div className="vin-header-data-container">
                                                    <span className="vin-header smallFont">
                                                        {vinDetailsHeader[3]}
                                                    </span>
                                                    <span className="vin-data smallFont">
                                                        {vin?.vin_status != "" ? vin?.vin_status : "-"}
                                                    </span>
                                                </div>
                                                <div className="vin-header-data-container">
                                                    <span className="vin-header smallFont">
                                                        {vinDetailsHeader[8]}
                                                    </span>
                                                    <span className="vin-data smallFont">
                                                        {vin?.vc_description != ""
                                                            ? vin?.vc_description
                                                            : "-"}
                                                    </span>
                                                </div>
                                                <div className="vin-header-data-container">
                                                    <span className="vin-header smallFont">
                                                        {vinDetailsHeader[5]}
                                                    </span>
                                                    <span className="vin-data smallFont">
                                                        {vin?.vc_number != "" ? vin?.vc_number : "-"}
                                                    </span>
                                                </div>
                                                {
                                                    vin.vin_coordinates ?
                                                        <>
                                                            <div className="vin-header-data-container">
                                                                <span className="vin-header smallFont">
                                                                    {vinDetailsHeader[4]}
                                                                </span>
                                                                <span className="vin-data smallFont"> {vin?.vin_coordinates[0]?.lat != "" ? vin?.vin_coordinates[0]?.lat : "-"} </span>
                                                            </div>
                                                            <div className="vin-header-data-container">
                                                                <span className="vin-header smallFont">
                                                                    {vinDetailsHeader[6]}
                                                                </span>
                                                                <span className="vin-data smallFont"> {vin?.vin_coordinates[0]?.lng != "" ? vin?.vin_coordinates[0]?.lng : "-"} </span>
                                                            </div>
                                                        </>
                                                        : null
                                                }
                                                <div className="vin-header-data-container">
                                                    <span className="vin-header smallFont">
                                                        {vinDetailsHeader[7]}
                                                    </span>
                                                    <span className="vin-data smallFont">
                                                        {vin?.updated_at != "" ? vin?.updated_at : "-"}
                                                    </span>
                                                </div>
                                                <div className="vin-header-data-container">
                                                    <span className="vin-header smallFont">
                                                        {vinDetailsHeader[9]}
                                                    </span>
                                                    <span className="vin-data smallFont">
                                                        {vin?.last_sync_date != "" ? vin?.last_sync_date : "-"}
                                                    </span>
                                                </div>
                                                <div className="vin-header-data-container">
                                                    <span className="vin-header smallFont">
                                                        {vinDetailsHeader[10]}
                                                    </span>
                                                    <span className="vin-data smallFont">
                                                        {vin?.fuel_level ? vin?.fuel_level : "-"}
                                                    </span>
                                                </div>
                                                <div className="vin-header-data-container">
                                                    <span className="vin-header smallFont">
                                                        {vinDetailsHeader[11]}
                                                    </span>
                                                    <span className="vin-data smallFont">
                                                        {vin?.fuel_vin_fk__fuel_updated_at ? vin?.fuel_vin_fk__fuel_updated_at : "-"}
                                                    </span>
                                                </div>
                                            </>
                                        );
                                    })}

                                </div>

                            </div>
                            <div ref={errorMessageRef} className="vin-search-head-container">
                            </div>
                            {/* <div className="vin-details-header mediumFont">Other Details</div> */}
                        </div>
                        <div className="map-container" id="map_container"></div>
                    </div>
                    <div className="horizontal-line" style={{ marginTop: "1rem" }}></div>
                    <div className="vin-details-footer">
                        <a
                            // href={`mailto:?subject=TYV - ${vinInfo[0]?.vin_number ? vinInfo[0]?.vin_number : "TYV"
                            //     }&body=Track Your Vehicle. Check this link http://maps.google.com/maps?q=loc:${vinInfo[0]?.vin_coordinates[0].lat},${vinInfo[0]?.vin_coordinates[0].lng}.`}
                            href={email_share_link}
                            data-action="share/email/share"
                            title="Share by Email"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <FooterButton
                                shouldEnable={true}
                                value="Share on Email"
                                backgroundColor="#82C1A7"
                                secondaryColor="#488f71"
                                handle={handleButton}
                            />


                        </a>
                    </div>
                </>
            ) : (
                <div
                    style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <Loader />
                </div>
            )}
            <style jsx="true">
                {`
                a {
                    text-decoration: none;
                    color: inherit;
                  }
            .footer-button {
                align-items: center;
                border: none;
                border-radius: 4px;
                box-shadow: 0 3px 3px rgb(0 0 67 / 13%);
                color: #fff;
                cursor: pointer;
                display: flex;
                font-weight: 700;
                line-height: 19px;
                padding: 0.5rem 2rem;
                text-align: center;
                text-transform: uppercase;
                white-space: nowrap;
            }
          /* Dont move it to any css file, keep it here only */
          .vin-search-head-container {
            text-transform: unset;
            color: #F17C7C;
            font-size: var(--smallFontSize);
            font-weight: 400;
            padding: 16px;
            // margin: 0 auto;
            // width: fit-content;
          }
          @media only screen and (max-width: 768px) {
            .vin-search-head-container {
                padding:16px;
              }

            .navbar {
              display: none;
            }
            
            .mob-secondary-navbar {
              width: calc(100% - 2rem);
              position: fixed;
              left: 0;
              top: 0;
            }
            .mob-secondary-header {
              display: flex;
              background: #f3f5f9;
              align-items: center;
              justify-content: space-between;
              padding: 0.25rem 1rem;
              font-weight: 600;
              line-height: 19px;
              color: #707070;
            }
            .mob-header-heading {
              display: flex;
              align-items: center;
            }
            .mob-header-heading img {
              height: 20px;
              margin-right: 0.5rem;
            }
          }
        `}
            </style>
        </>
    );
};

export default VinDetails;
